import React, { Component } from "react";
import { useNavigate, Link } from "react-router-dom";
import { CheckUser } from "../../Model/Users";
import { getTopics, submitInterest } from "../../Model/Common";

import { motion } from "framer-motion";
import {
  withRouter,
  importAll,
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  Imgbanner,
  Decrypt,
} from "../../Helpers/Common";
import BarLoader from "react-spinners/BarLoader";

import { SubscriptionPlans } from "../../Model/Subscription";
var ImageData = "";
var SVGIcon = "";
var ImgbannerData = "";

Imgbanner().then((result) => (ImgbannerData = result));
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class SelectTopics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: false,
      VirsionCheckDataloaded: false,
      topicsList: false,
      selected: {},
      ButtonEnable: true,
    };
    this.submitselectTopics = this.submitselectTopics.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const target = e.target;
    var value = target.value;
    var name = target.name;
    var fields = this.state.selected;
    if (target.checked) {
      fields[e.target.name] = e.target.value;
    } else {
      const o = fields;
      o.hasOwnProperty(e.target.name); // true
      delete o[e.target.name];
      o.hasOwnProperty(e.target.name); // false
    }

    if (Object.keys(this.state.selected).length > 0) {
      this.setState({ ButtonEnable: false });
    } else {
      this.setState({ ButtonEnable: true });
    }
  }

  submitselectTopics(e) {
    e.preventDefault();
    const filtered = Object.values(this.state.selected);
    CheckUser().then((res) => {
      var postdata = {
        interest: filtered,
        user_id: res.user_data.ID,
        session_id: res.session_id,
      };
      submitInterest(postdata).then((res) => {
        if (sessionStorage.getItem("refferalUrl")) {
          this.props.navigate(sessionStorage.getItem("refferalUrl"));
          sessionStorage.removeItem("refferalUrl");
        } else {
          this.props.navigate("/");
        }
      });
    });
  }

  componentDidMount() {
    //Get Get User checked Check Data
    CheckUser().then((checkuserstatus) => {
      if (checkuserstatus == null) {
        this.props.navigate("/createaccount");
      }
    });

    getTopics().then((topicsList) => {
      var Topicslist = topicsList.data.message;
      this.setState({
        topicsList: Topicslist,
      });
    });

    VirsionCheck().then((virsioncheckResponse) => {
      this.setState({
        VirsionCheckData: virsioncheckResponse,
        VirsionCheckDataloaded: true,
      });
    });
  }

  render() {
    var counter = 0;
    var data = 0;
    var Cssclass = [
      "technology",
      "music",
      "crime",
      "adventure",
      "biography",
      "science",
      "travel",
      "nature",
      "sports",
      "culture",
      "humanity",
      "politics",
      "ecology",
      "transportation",
      "arts",
      "entertainment",
    ];
    if (
      this.state.VirsionCheckDataloaded == false ||
      this.state.topicsList == false
    ) {
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }
    var SelectTopicsData = JSON.parse(this.state.VirsionCheckData.data).data
      .banner_images.signup_step_5_1;
    var topics = this.state.topicsList;
    return (
      <>
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="temp4 dD-none">
            <hr className="border-red" />
            <hr className="border-red" />
            <div className="temp4-InnerRound50">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
            <div className="temp4-InnerRound51">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
            <div className="temp4-InnerRound52">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
          </div>
          <header className="dD-none">
            <div className="mainNav">
              <div className="docubayBack white pl-8">Get started</div>
              <div className="topQuestion">
                {/*<img src="./img/svg/help.svg" alt="help" />*/}
              </div>
            </div>
          </header>
          <main className="dD-none">
            <section className="mb-0">
              <div className="homeBanner">
                <div className="innerBanner">
                  {/* <picture>
                    <source
                      srcSet={SelectTopicsData.ipad_banner_image}
                      media="(min-width: 700px)"
                    />
                    <source
                      srcSet={SelectTopicsData.ipad_banner_image}
                      media="(min-width: 768px)"
                    />
                    <source
                      srcSet={ImgbannerData["sign-up.png"]}
                      media="(min-width: 650px)"
                    />
                    <source
                      srcSet={SelectTopicsData.banner_image_url}
                      media="(min-width: 300px)"
                    />
                    <img
                      src={SelectTopicsData.banner_image_url}
                      alt="Sign up"
                    />
                  </picture> */}
                  <div className="title">
                    <h2 className="line-height">{SelectTopicsData.text_one}</h2>
                    <h1 className="mb-20">
                      {SelectTopicsData.text_two}{" "}
                      <span className="red">{SelectTopicsData.text_three}</span>
                    </h1>
                    <h4>{SelectTopicsData.text_four}</h4>
                  </div>
                </div>
              </div>

              <div className="explore-bg-img"></div>
            </section>

            <section className="mb-0">
              <form
                method="post"
                name="select_topics_form"
                onSubmit={this.submitselectTopics}
                noValidate="novalidate"
              >
                <div className="temp9">
                  <div className="temp9-head">
                    <h3>Select topics</h3>
                    <button
                      className="skip"
                    >
                      Skip <img src="./img/svg/skip-arrow.svg" />
                    </button>
                  </div>
                  <div className="temp9-area">
                    <div className="temp9-Box">
                      {topics.Genres?.map((topics, index) => {
                        if (index >= 16) {
                          data = data + 1;
                          counter = data;
                        } else {
                          counter = index;
                        }
                        return (
                          <div className="temp9-chkbox" key={index}>
                            <label className={Cssclass[counter]}>
                              <input
                                type="checkbox"
                                onChange={(e) => this.handleChange(e)}
                                value={topics.name}
                                name={topics.ID}
                              />
                              <span>{topics.name}</span>
                            </label>
                          </div>
                        );
                      })}
                    </div>

                    <div className="temp9-btn mt-24">
                      <button
                        type="submit"
                        disabled={this.state.ButtonEnable}
                        className={
                          this.state.ButtonEnable ? "btn-black" : "btn-red"
                        }
                      >
                        Start Watching
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </main>

          {/* desktop section */}
          {/*
     
       
          <main className="dD-block ">
            <section className="mb-0">
              <div className="homeBanner">
                <div className="innerBanner">
                  <picture>
                    <source srcSet={ImageData["skip-watchDesk-m1.png"]} />
                    <source srcSet={ImageData["skip-watch-m1.png"]} />
                    <img src={ImageData["skip-watch-m1.png"]} alt="Sign up" />
                  </picture>loader
                  <div className="select-title dD-block">
                    <h4>{SelectTopicsData.text_one}</h4>
                    <h1 className="mb-20">
                      {SelectTopicsData.text_two} <span className="red">{SelectTopicsData.text_three}</span>
                    </h1>
                  </div>
                </div>
                
              </div>
            </section>
          </main> */}
          <main className="bg-img dD-block">
            <header className="dD-block">
              <div className="mainNav pmenu policy-left">
                <div className="docubayLogo">
                  <img
                    src={ImageData["docu-bay-white.png"]}
                    alt="DocuBay Logo"
                  />
                </div>
              </div>
            </header>
            <section style={{ position: "relative" }}>
              <div className="temp4 temp4-desk dD-block ">
                <hr className="border-red" />
                <hr className="border-red" />
                <div className="temp4-InnerRound50">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
                <div className="temp4-InnerRound51">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
                <div className="temp4-InnerRound52">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
              </div>
            </section>
            <section style={{ marginTop: "7rem" }}>
              <div>
                <div className="select-title dD-block">
                  <h4>{SelectTopicsData.text_one}</h4>
                  <h1 className="mb-20">
                    {SelectTopicsData.text_two}{" "}
                    <span className="red">{SelectTopicsData.text_three}</span>
                  </h1>
                </div>
                <form
                  method="post"
                  name="select_topics_form"
                  onSubmit={this.submitselectTopics}
                  noValidate="novalidate"
                >
                  <div className="temp9">
                    <div className="temp9-head">
                      <h3>Select topics</h3>
                    </div>
                    <div className="temp9-area">
                      <div className="temp9-Box">
                        {topics.Genres?.map((topics, index) => {
                          if (index >= 16) {
                            data = data + 1;
                            counter = data;
                          } else {
                            counter = index;
                          }
                          return (
                            <div className="temp9-chkbox" key={index}>
                              <label className={Cssclass[counter]}>
                                <input
                                  type="checkbox"
                                  onChange={(e) => this.handleChange(e)}
                                  value={topics.name}
                                  name={topics.ID}
                                />
                                <span>{topics.name}</span>
                              </label>
                            </div>
                          );
                        })}
                      </div>
                      <div className="Select-buttons">
                        <div className="temp9-btn mt-24">
                          {/* <Link
                            to={
                              sessionStorage.getItem("refferalUrl")
                                ? sessionStorage.getItem("refferalUrl")
                                : "/"
                            }
                          > */}
                            <button
                              type="submit"
                              className="btn-black text-white"
                            >
                              Skip
                            </button>
                          {/* </Link> */}
                        </div>
                        <div className="temp9-btn mt-24">
                          <button
                            type="submit"
                            disabled={this.state.ButtonEnable}
                            className={
                              this.state.ButtonEnable ? "btn-black" : "btn-red"
                            }
                          >
                            Start Watching
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </section>
          </main>
        </motion.div>
      </>
    );
  }
}

export default withRouter(SelectTopics);
